module.exports = {"override":"Station Pricebook","create_override":"Create Station Pricebook","remove_override":"Remove Station Pricebook","update_override":"Update Station Pricebook","add_override_products":"Add Station Pricebook Products","update_override_products":"Update Station Pricebook Products","tags":"Sales Category","categories":"Loyalty Category","add_products_from_tags":"Add products from sales category","add_products_from_categories":"Add products from loyalty category"};


//////////////////
// WEBPACK FOOTER
// ./resources/lang/en_sentinel/station_pricebook.php
// module id = hO81
// module chunks = 99